import {getField, updateField} from "vuex-map-fields"
import {Api} from "@/plugins/axios"


export const state = () => ({
    adminId: null,
    dates: [],
    editing: false,
    dashboard_referral_selected: null,
    dashboardFeatures: [],
    processedData: [],
    currentProgress: []
})

export const getters = {
    getField,
    currentProgress(state){
        return state.currentProgress
    },
    dashboardFeatures(state){
        return state.dashboardFeatures
    },
    processedData(state){
        return state.processedData
    }
}

export const mutations = {
    updateField,
    addProcessedData(state, data) {
        if (state.processedData.length < 1) {
            state.processedData.push(data)
        }    
    },
    updateProcessedData(state, processedData) {
        state.processedData[0].levels = processedData.processedData.levels;
    },
  }

export const actions = {
    addDashboardFeature({ commit }, feature) {
        commit('addDashboardFeature', feature)
    },
    addCurrentProgress({ commit }, currentProgress) {
        commit('addCurrentProgress', currentProgress)
    },
    addProcessedData({ commit }, processedData) {
        commit('addProcessedData', processedData)
    },
    updateProcessedData({ commit }, processedData) {
        commit('updateProcessedData', processedData)
    },
}